/**
 * "Right now": one row per robot (twin slice 1, plan W5 step 13). The rows
 * and their words are `rightNow()`'s; this only lays them out. A row that
 * is not reporting now is dimmed.
 */
import { ATTENTION_LABELS } from '../../../state/attention/card-words';
import type { RightNowGroup } from '../../../state/attention/right-now';
import './attention.css';

export function RightNowList({ groups }: { groups: readonly RightNowGroup[] }) {
  if (groups.length === 0) return null;
  return (
    <section className="nx-right-now" aria-label={ATTENTION_LABELS.rightNow}>
      <h3 className="nx-attention-column__heading">{ATTENTION_LABELS.rightNow}</h3>
      {groups.map((g) => (
        <div key={g.level ?? '-'} className="nx-right-now__group">
          {g.heading ? <h4 className="nx-right-now__floor">{g.heading}</h4> : null}
          <ul className="nx-right-now__rows">
            {g.rows.map((r) => (
              <li
                key={r.key}
                className={`nx-right-now__row${r.dim ? ' nx-right-now__row--dim' : ''}`}
                data-dim={r.dim ? 'true' : undefined}
              >
                <span className="nx-right-now__name">{r.name}</span>
                {r.simulated ? (
                  <span className="nx-right-now__sim">{ATTENTION_LABELS.simulated}</span>
                ) : null}
                <span className="nx-right-now__state">
                  {[r.where, r.state, r.battery].filter((x): x is string => Boolean(x)).join(' · ')}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
